import animejs from 'animejs'

export const shaking = element => {
  const xMax = 12
  animejs({
    targets: element,
    easing: 'easeInOutSine',
    duration: 550,
    translateX: [
      {
        value: xMax * -1
      },
      {
        value: xMax
      },
      {
        value: xMax / -2
      },
      {
        value: xMax / 2
      },
      {
        value: 0
      }
    ]
  })
}
